import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDischarge4MasterReferenceData = createAsyncThunk(
  'stop/getVerificationDischarge4MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDischarge4MasterReferenceSlice = createSlice({
  name: 'stop/verificationDischarge4MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationDischarge4MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDischarge4MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDischarge4MasterReference } =
  verificationDischarge4MasterReferenceSlice.actions;

export default verificationDischarge4MasterReferenceSlice.reducer;
